export enum PipelineActivityType {
  SavedQuote = "SavedQuote",
}

export interface ActivityModel {
  activityTypeId: PipelineActivityType;
  activityTypeName: string;
  activityTime: string;
}
